import LanguageDTO from "../languageDTO";

export class Audience_TranslationDTO {
  audienceId: number;

  languageId: number;

  name: string;

  description?: string;

  lang?: LanguageDTO;

  constructor() {
    this.audienceId = 0;
    this.languageId = 0;
    this.name = '';
  }
}
